import { css, cx } from '@emotion/css'
import type { CheckboxProps } from '@mantine/core'
import { Checkbox as MantineCheckbox } from '@mantine/core'
import type { FC } from 'react'
import { colors } from 'settings/colors'

export const Checkbox: FC<CheckboxProps> = (props) => {
  const callerClassNames = typeof props.classNames === 'object' ? props.classNames : {}

  return (
    <MantineCheckbox
      size="sm"
      {...props}
      classNames={{
        ...callerClassNames,
        // Input rules sit under the root, so a caller's `classNames.input` class can't override them; a caller
        // that must win needs a more specific selector.
        root: cx(
          css({
            '& input': {
              cursor: 'pointer',
              backgroundColor: colors.grey200,
              borderColor: colors.grey200,
              boxShadow: 'inset 0px 2px 2px -1px rgba(74, 74, 104, 0.1)',
            },
            '& input:checked': {
              backgroundColor: colors.primary,
              borderColor: colors.primary,
            },
            '& input:disabled': {
              backgroundColor: colors.grey200,
              borderColor: colors.grey200,
            },
          }),
          callerClassNames.root,
        ),
        label: cx(
          css({ 'cursor': 'pointer', '&:not([data-disabled])': { color: colors.midnight } }),
          callerClassNames.label,
        ),
      }}
    />
  )
}
